import { Component, OnInit, Input, OnChanges, SimpleChanges, ViewChild, Output, EventEmitter } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { FormGeneratorService, TableMode, TableEvent, BaseModel } from '@ngx-resource-toolkit/core';
import { FactureModel } from '../models/facture.model';
import { HttpClient } from '@angular/common/http';
import { CalculMontantService } from '../../services/calcul-montant.service';
import { ToasterService } from 'angular2-toaster';
import { SettingsService } from '../../../core/settings/settings.service';
import { ModalConfirmationComponent } from '../../miscellaneous/modal-confirmation.component';
import { ExportService } from '../../services/export.service';
import { Router } from '@angular/router';
import { TabsService } from '../../services/tabs.service';
import { ParametreModel } from '../../../parametrage/listes/parametres/parametre.model';
import { ObjetLight } from '../../objetLight/models/ObjetLight';
import { SelectionType } from '@swimlane/ngx-datatable';

@Component({
  selector: 'list-facture',
  templateUrl: './list.component.html',
  styleUrls: ['./list.component.scss']
})
export class ListFactureComponent implements OnInit, OnChanges {

  public TableMode = TableMode;
  anneeScolaire: number;

  @ViewChild('modal') modal: any;
  @ViewChild(ModalConfirmationComponent) modalConfirmation: any;

  @Input() public familleId: string;
  @Input() public familleNom: string;
  @Input() public factures: FactureModel[];
  @Input() public buttons: string[];
  @Input() public loading: boolean;

  @Output() calcul: EventEmitter<{ model: any, params: any[] }> = new EventEmitter<{ model: any, params: any[] }>();
  @Output() create: EventEmitter<{ model: any, params: any[] }> = new EventEmitter<{ model: any, params: any[] }>();
  // tslint:disable-next-line:max-line-length
  @Output() update: EventEmitter<{ model: any, form: FormGroup, params: any[] }> = new EventEmitter<{ model: any, form: FormGroup, params: any[] }>();
  @Output() delete: EventEmitter<{ model: any, id: number, idFamille: number }> = new EventEmitter<{ model: any, id: number, idFamille: number }>();
  @Output() cancel: EventEmitter<{ model: any, params: any[] }> = new EventEmitter<{ model: any, params: any[] }>();

  // tslint:disable-next-line:max-line-length
  @Output() valide: EventEmitter<{ model: any, form: FormGroup, params: any[] }> = new EventEmitter<{ model: any, form: FormGroup, params: any[] }>();
  @Output() refresh = new EventEmitter(); // Traitement terminé => demander à recharger les données si nécessaire
  public model: BaseModel; // BaseModel;
  public factureModel: BaseModel; // FactureModel; // BaseModel;

  public forms: any;
  public factureForm: FormGroup;

  public isModalCreate: boolean;
  public buttonTypeConfirmation: string = 'delete';

  public confirmationMessage: string;
  public confirmationEvent: any;

  public isValidationAutorise: boolean = false; // L'utilisateur a-t-il le droit de valider une facture
  public isSuppressionFactureValideePossible: boolean = false;

  public selected: Array<ObjetLight> = [];
  @Input() public selectedFactures: Array<FactureModel> = [];
  SelectionType = SelectionType;
  @Input() public selectionType = SelectionType.multiClick;

  constructor(
    private settings: SettingsService,
    private toaster: ToasterService,
    private http: HttpClient,
    private formGenerator: FormGeneratorService,
    private exportService: ExportService,
    private calculMontant: CalculMontantService,
    private router: Router,
    private tabsService: TabsService,
  ) {

  }

  ngOnInit() {
    this.anneeScolaire = this.settings.getUserSetting('anneeScolaire');
    this.isValidationAutorise = this.settings.isUserMenuAllowed('FACTURE_VALIDATION', 'isCreation');
    // récupérer paramètre "FACTURATION", "SuppFactValidAutoris" pour savoir si on peut supprimer une facture validée ou seulement l'annuler
    const param = new ParametreModel();
    param.getResource('default', 'get').call(this.http, 'getParametreObject', ['FACTURATION', 'SuppFactValidAutoris'])
      .subscribe(data => {
        // console.log({ ou: 'list.component (factures).ngOnInit', data });
        if (data) {
          this.isSuppressionFactureValideePossible = +data.valeur === 1;
        }
      });
    // console.log({ isValidationAutorise: this.isValidationAutorise });
  }

  ngOnChanges(changes: SimpleChanges): void {
    // console.log('ListFactureComponent', 'ngOnChanges', changes);
    if (this.factures) {

      this.model = new FactureModel({});
      this.resetFactureModels();

      this.forms = this.formGenerator.createFormGroup(this.factures, 'table');

      this.calculMontant.updateValues({ factures: this.factures });
      // this.updateTotalPaiement();
    }

    // console.log('ListFactureComponent', 'forms', this.forms, this.famille);
  }

  openConfirmationDelete(event: TableEvent) {
    this.confirmationEvent = event;
    if (event.row.isValide && !this.isSuppressionFactureValideePossible) {
      this.confirmationMessage = `Voulez-vous vraiment annuler la facture n°${event.row.id} ?`;
      this.buttonTypeConfirmation = 'cancel_invoice';
    } else {
      this.confirmationMessage = `Voulez-vous vraiment supprimer la facture n°${event.row.id} ?`;
      this.buttonTypeConfirmation = 'delete';
    }
    console.log('OpenConfirmation', { confirmationMessage: this.confirmationMessage, confirmationEvent: this.confirmationEvent });
    this.modalConfirmation.modal.open();
  }

  calculerFacture() {
    this.calcul.emit({ model: this.model, params: [this.familleId, this.settings.getUserSetting('anneeScolaire')] });
  }

  createFacture() {
    this.isModalCreate = true;
    this.create.emit({ model: this.model, params: [this.familleId, this.settings.getUserSetting('anneeScolaire')] });
  }

  openEditFacture(event: TableEvent) {
    // console.log('openEditFacture', event);
    this.model.getResource('default', 'get')
      .call(this.http, 'findById', [event.row['id']])
      .subscribe((data) => {
        // console.log(data);
        this.isModalCreate = false;
        //event.row.idFamille = this.familleId || event.row.idFamille;
        //event.row.familleNom = this.familleNom || event.row.familleNom;
        this.factureModel = new FactureModel(data);
        this.factureForm = this.formGenerator.createFormGroup(this.factureModel, 'edit-facture');
        this.modal.open();
      });
  }

  printFacture(event: TableEvent) {
    console.log('printFacture', event);
    const factureModel: BaseModel = new FactureModel(event.row);
    const params = [event.row.id, this.settings.getUserSetting('anneeScolaire')];
    // const service = 'facturation';
    const method = 'genereFacturePDF';
    const fileNameOnDisk = 'Facture_' + event.row.id;
    this.exportService.generePDF(factureModel, params, method, fileNameOnDisk);
  }

  saveFacture() {
    console.log('saveFacture', this.factureForm, this.model);
    this.update.emit({ model: this.model, form: this.factureForm, params: [this.factureForm.controls['removedLignesFacture'].value] });
    // console.log('ListFactureComponent', 'factureForm', this.factureForm);
    // this.factureModel.getResource('default', 'post').call(this.http, 'saveFacture', this.factureForm, [this.factureForm.controls['removedLignesFacture'].value]).subscribe((data) => {
    //   const facture = new FactureModel(data);

    //   // Map new facture in famille facture list
    //   this.famille.factures = this.famille.factures.reduce((acc, curr, index, array) => {
    //     if (facture.id == curr.id) {
    //       acc.push(facture);
    //     } else {
    //       acc.push(curr);
    //     }
    //     return acc;
    //   }, []);

    //   this.calculMontant.updateValues({factures: this.famille.factures});

    //   this.modal.close();

    // }, (err) => {
    //   console.log('ListFactureComponent', 'save facture error', err);
    //   this.toaster.pop('error', `Erreur lors de la mise à jour de la facture`);
    // })
  }

  openConfirmationValide() {
    // console.log('openConfirmationValide', {model: this.model, form: this.factureForm});
    this.confirmationEvent = new EventEmitter(true);
    // tslint:disable-next-line:max-line-length
    this.confirmationMessage = `Confirmez-vous la validation de la facture n°${this.factureForm.value.id} ? (une facture validée ne peut plus être modifiée)`;
    this.buttonTypeConfirmation = 'valide';
    // console.log('OpenConfirmation', {confirmationMessage: this.confirmationMessage, confirmationEvent: this.confirmationEvent});
    this.modalConfirmation.modal.open();
  }
  defaultAction(params: any) {
    console.log('defaultAction destination', params);
    switch (params.buttonType) {
      case 'valide':
        console.log('Validation facture demandée', params.event.row); // params.data n'est pas utilisé, on peut l'enlever à priori
        // const facture = this.factureForm.value;
        this.valide.emit({ model: this.model, form: this.factureForm, params: [] });
        break;
      case 'cancel_invoice':
        console.log('Annulation facture demandée', params.event.row);
        this.cancel.emit({ model: this.model, params: [params.event.row.id] });
        break;
    }
  }
  deleteFacture(event: TableEvent) {
    console.log({ ou: 'deleteFacture', model: this.model, params: [{ id: event.row.id }], event });
    this.delete.emit({ model: this.model, id: event.row.id, idFamille: event.row.idFamille });
  }

  cancelFacture(event: TableEvent) {
    console.log({ ou: 'cancelFacture' });
  }

  private resetFactureModels(model?) {
    const data = model || {
      idFamille: this.familleId,
      familleNom: this.familleNom,
      anneeScolaire: this.settings.getUserSetting('anneeScolaire'),
      periode: 1, // TODO: get value from confservice
    };
    this.factureModel = new FactureModel(data);
    this.factureForm = this.formGenerator.createFormGroup(this.factureModel, 'create');
  }

  isButtonInList(value: string) {
    return this.buttons instanceof Array ? this.buttons.includes(value) : false;
  }

  ouvreFamilleConsultation(nomFamille, idFamille) {
    // Laisser le nom en premier paramètre (même si non utilisé dans la fonction) car permet de garder le tri 
    // de la colonne sur cette donnée.
    this.router.navigate(['/famille/show', idFamille]);

    this.tabsService.addTab({
      label: `${nomFamille} (${idFamille})`,
      link: '/famille/show/' + idFamille,
      group: 'famille',
      iconClass: 'fa fa-user'
    });
  }

  private listFacturesToListObjetLight(listFactures: Array<FactureModel>) {
    const listeLightObject: Array<ObjetLight> = [];
    listFactures.forEach(element => {
      const objSel: ObjetLight = new ObjetLight({
        id: element.id,
        libelle: 'Facture famille ' + element.familleNom,
        typeObjet: 'I'
      });
      listeLightObject.push(objSel);
    });
    // console.log({ where: 'listFacturesToListObjetLight', listeLightObject});
    return listeLightObject;
  }

  onSelect(selected) {
    // console.log({ where: 'ListFactureComponent.onSelect', selected, selectedBefore: this.selected });
    if (selected != null) {
      this.selected.splice(0, this.selected.length);
      this.selected = this.listFacturesToListObjetLight(selected);
    } else {
      this.selected = [];
    }
    // console.log({ where: 'onSelect (end)', selected: this.selected});
  }

  selectionChanged(factursSelectionnees) {
    // console.log('selectionChanged', factursSelectionnees);
    this.selected = factursSelectionnees;
    // Mise à jour de la sélection dans le tableau
    this.selectedFactures = [];
    this.selected.forEach(element => {
      // element.id
      const elementSelectionne = this.factures.find(function (cur: FactureModel) {
        return +cur.id === element.id;
      });
      this.selectedFactures.push(elementSelectionne);
    });
    // console.log( {selected: this.selected, factursSelectionnees });
  }

  /**
   * Sélectionne toutes les factures.
   */
  selectedAll() {
    this.selected.splice(0, this.selected.length);
    this.selected = this.listFacturesToListObjetLight(this.factures);
    this.selectedFactures = this.factures;
  }

  finished() {
    this.refresh.emit();
  }

  email(event) {
    console.log('email', event);
    const id = event.row.id;
    this.router.navigate(['courriel/facture', id]);
  }
}



// WEBPACK FOOTER //
// /builds/eveasoft/lea/lea-front/src/app/shared/facture/list/list.component.ts